// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { EnumInheritanceModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumInheritanceModifier';
import { EnumPersistenceType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumPersistenceType';
import { EnumEntityStructureType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';
import { EnumTreeEntityLevel } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumTreeEntityLevel';
import { BEComponent } from './BEComponent';
import { Implement } from './Implement';
import { Association } from './Association';
import { Aggregation } from './Aggregation';
import { Composition } from './Composition';
import { EntityGeneration } from './EntityGeneration';
import { BEReferenceEntity } from './BEReferenceEntity';
import { CrossAssociation } from './CrossAssociation';
import { ReferCrossAssociation } from './ReferCrossAssociation';
import { DependencyAssociation } from './DependencyAssociation';
import { BEAttribute } from './BEAttribute';
import { EntityMethod } from './EntityMethod';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEEntityExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEEntityExtend';
/**
 * 实体 实体类
 * 实体
 */
export class BEEntity extends BETypeElement {
  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 继承修饰符 : 继承修饰符定义实体为抽象或最终类 */
  private _inheritanceModifier: EnumInheritanceModifier;

  /** 设置：继承修饰符 */
  public get inheritanceModifier() {
    return this._inheritanceModifier;
  }

  /** 获取：继承修饰符 */
  public set inheritanceModifier(value: EnumInheritanceModifier) {
    this._inheritanceModifier = value;
  }

  /** 持久化类型 : 持久化类型 */
  private _persistenceType: EnumPersistenceType;

  /** 设置：持久化类型 */
  public get persistenceType() {
    return this._persistenceType;
  }

  /** 获取：持久化类型 */
  public set persistenceType(value: EnumPersistenceType) {
    this._persistenceType = value;
  }

  /** 缺省表名 : 缺省表名 */
  private _defaultTableName: string;

  /** 设置：缺省表名 */
  public get defaultTableName() {
    return this._defaultTableName;
  }

  /** 获取：缺省表名 */
  public set defaultTableName(value: string) {
    this._defaultTableName = value;
  }

  /** 插入前事件 : 是否自动挂接插入前事件，在执行数据库插入之前执行，需要提供扩展实现代码 */
  private _hasInsertingEvent: boolean;

  /** 设置：插入前事件 */
  public get hasInsertingEvent() {
    return this._hasInsertingEvent;
  }

  /** 获取：插入前事件 */
  public set hasInsertingEvent(value: boolean) {
    this._hasInsertingEvent = value;
  }

  /** 插入后事件 : 是否自动挂接插入后事件，在执行数据库插入之后执行，需要提供扩展实现代码 */
  private _hasInsertedEvent: boolean;

  /** 设置：插入后事件 */
  public get hasInsertedEvent() {
    return this._hasInsertedEvent;
  }

  /** 获取：插入后事件 */
  public set hasInsertedEvent(value: boolean) {
    this._hasInsertedEvent = value;
  }

  /** 更新前事件 : 是否自动挂接更新前事件，在执行数据库更新之前执行，需要提供扩展实现代码 */
  private _hasUpdatingEvent: boolean;

  /** 设置：更新前事件 */
  public get hasUpdatingEvent() {
    return this._hasUpdatingEvent;
  }

  /** 获取：更新前事件 */
  public set hasUpdatingEvent(value: boolean) {
    this._hasUpdatingEvent = value;
  }

  /** 更新后事件 : 是否自动挂接更新后事件，在执行数据库更新之后执行，需要提供扩展实现代码 */
  private _hasUpdatedEvent: boolean;

  /** 设置：更新后事件 */
  public get hasUpdatedEvent() {
    return this._hasUpdatedEvent;
  }

  /** 获取：更新后事件 */
  public set hasUpdatedEvent(value: boolean) {
    this._hasUpdatedEvent = value;
  }

  /** 逻辑删除前事件 : 是否自动挂接逻辑删除前事件，在执行数据库逻辑删除之前执行，需要提供扩展实现代码 */
  private _hasDeletingEvent: boolean;

  /** 设置：逻辑删除前事件 */
  public get hasDeletingEvent() {
    return this._hasDeletingEvent;
  }

  /** 获取：逻辑删除前事件 */
  public set hasDeletingEvent(value: boolean) {
    this._hasDeletingEvent = value;
  }

  /** 逻辑删除后事件 : 是否自动挂接逻辑删除后事件，在执行数据库逻辑删除之后执行，需要提供扩展实现代码 */
  private _hasDeletedEvent: boolean;

  /** 设置：逻辑删除后事件 */
  public get hasDeletedEvent() {
    return this._hasDeletedEvent;
  }

  /** 获取：逻辑删除后事件 */
  public set hasDeletedEvent(value: boolean) {
    this._hasDeletedEvent = value;
  }

  /** 恢复前事件 : 是否自动挂接恢复前事件，在执行数据库恢复之前执行，需要提供扩展实现代码 */
  private _hasRestoringEvent: boolean;

  /** 设置：恢复前事件 */
  public get hasRestoringEvent() {
    return this._hasRestoringEvent;
  }

  /** 获取：恢复前事件 */
  public set hasRestoringEvent(value: boolean) {
    this._hasRestoringEvent = value;
  }

  /** 恢复后事件 : 是否自动挂接恢复后事件，在执行数据库恢复之后执行，需要提供扩展实现代码 */
  private _hasRestoredEvent: boolean;

  /** 设置：恢复后事件 */
  public get hasRestoredEvent() {
    return this._hasRestoredEvent;
  }

  /** 获取：恢复后事件 */
  public set hasRestoredEvent(value: boolean) {
    this._hasRestoredEvent = value;
  }

  /** 物理删除前事件 : 是否自动挂接物理删除前事件，在执行数据库物理删除之前执行，需要提供扩展实现代码 */
  private _hasRemovingEvent: boolean;

  /** 设置：物理删除前事件 */
  public get hasRemovingEvent() {
    return this._hasRemovingEvent;
  }

  /** 获取：物理删除前事件 */
  public set hasRemovingEvent(value: boolean) {
    this._hasRemovingEvent = value;
  }

  /** 物理删除后事件 : 是否自动挂接物理删除后事件，在执行数据库物理删除之后执行，需要提供扩展实现代码 */
  private _hasRemovedEvent: boolean;

  /** 设置：物理删除后事件 */
  public get hasRemovedEvent() {
    return this._hasRemovedEvent;
  }

  /** 获取：物理删除后事件 */
  public set hasRemovedEvent(value: boolean) {
    this._hasRemovedEvent = value;
  }

  /** 是否前端可见 : 是否前端可见，false代表不对前端输出，前端不可见 */
  private _isForFront: boolean;

  /** 设置：是否前端可见 */
  public get isForFront() {
    return this._isForFront;
  }

  /** 获取：是否前端可见 */
  public set isForFront(value: boolean) {
    this._isForFront = value;
  }

  /** 需要审核 : 是否需要审核，审核实体会自动生成对应的按钮、权限等信息，新建数据为等待状态，审核通过以后变为有效 */
  private _needAudit: boolean;

  /** 设置：需要审核 */
  public get needAudit() {
    return this._needAudit;
  }

  /** 获取：需要审核 */
  public set needAudit(value: boolean) {
    this._needAudit = value;
  }

  /** 实体结构类型 : 实体结构类型 */
  private _entityStructureType: EnumEntityStructureType;

  /** 设置：实体结构类型 */
  public get entityStructureType() {
    return this._entityStructureType;
  }

  /** 获取：实体结构类型 */
  public set entityStructureType(value: EnumEntityStructureType) {
    this._entityStructureType = value;
  }

  /** 树形最大层级 : 树形结构实体的最大层级，引用的时候必须选择最大层级的数据 */
  private _treeEntityLevel: EnumTreeEntityLevel;

  /** 设置：树形最大层级 */
  public get treeEntityLevel() {
    return this._treeEntityLevel;
  }

  /** 获取：树形最大层级 */
  public set treeEntityLevel(value: EnumTreeEntityLevel) {
    this._treeEntityLevel = value;
  }

  /** 租户实体 : 是否是租户实体。租户实体在操作的时候会受到租户条件限制 */
  private _isTenantEntity: boolean;

  /** 设置：租户实体 */
  public get isTenantEntity() {
    return this._isTenantEntity;
  }

  /** 获取：租户实体 */
  public set isTenantEntity(value: boolean) {
    this._isTenantEntity = value;
  }

  /** 父实体 的ID */
  private _superEntity_ID: string;

  /** 获取：父实体 的ID */
  public get superEntity_ID() {
    return this._superEntity_ID;
  }

  /** 设置：父实体 的ID */
  public set superEntity_ID(value: string) {
    this._superEntity_ID = value;
  }

  /** 父实体  */
  private _superEntity: BEEntity;

  /** 获取：父实体  */
  public get superEntity() {
    return this._superEntity;
  }

  /** 设置：父实体  */
  public set superEntity(value: BEEntity) {
    this._superEntity = value;
    if (value !== null) {
      this.superEntity_ID = value.id;
    } else {
      this.superEntity_ID = '';
    }
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 实现关系集合 */
  private _implements: Array<Implement>;

  /** 获取：实现关系集合 */
  public get implements() {
    return this._implements;
  }

  /** 设置：实现关系集合 */
  public set implements(value: Array<Implement>) {
    this._implements = value;
  }

  /** 作为源的关联关系 */
  private _sourceAssociations: Array<Association>;

  /** 获取：作为源的关联关系 */
  public get sourceAssociations() {
    return this._sourceAssociations;
  }

  /** 设置：作为源的关联关系 */
  public set sourceAssociations(value: Array<Association>) {
    this._sourceAssociations = value;
  }

  /** 作为目标的关联关系 */
  private _targetAssociations: Array<Association>;

  /** 获取：作为目标的关联关系 */
  public get targetAssociations() {
    return this._targetAssociations;
  }

  /** 设置：作为目标的关联关系 */
  public set targetAssociations(value: Array<Association>) {
    this._targetAssociations = value;
  }

  /** 作为源的聚合关系 */
  private _sourceAggregations: Array<Aggregation>;

  /** 获取：作为源的聚合关系 */
  public get sourceAggregations() {
    return this._sourceAggregations;
  }

  /** 设置：作为源的聚合关系 */
  public set sourceAggregations(value: Array<Aggregation>) {
    this._sourceAggregations = value;
  }

  /** 作为目标的聚合关系 */
  private _targetAggregations: Array<Aggregation>;

  /** 获取：作为目标的聚合关系 */
  public get targetAggregations() {
    return this._targetAggregations;
  }

  /** 设置：作为目标的聚合关系 */
  public set targetAggregations(value: Array<Aggregation>) {
    this._targetAggregations = value;
  }

  /** 作为源的组合关系 */
  private _sourceCompositions: Array<Composition>;

  /** 获取：作为源的组合关系 */
  public get sourceCompositions() {
    return this._sourceCompositions;
  }

  /** 设置：作为源的组合关系 */
  public set sourceCompositions(value: Array<Composition>) {
    this._sourceCompositions = value;
  }

  /** 作为目标的组合关系 */
  private _targetCompositions: Array<Composition>;

  /** 获取：作为目标的组合关系 */
  public get targetCompositions() {
    return this._targetCompositions;
  }

  /** 设置：作为目标的组合关系 */
  public set targetCompositions(value: Array<Composition>) {
    this._targetCompositions = value;
  }

  /** 实体继承关系集合（当前为父实体） */
  private _superGenerations: Array<EntityGeneration>;

  /** 获取：实体继承关系集合（当前为父实体） */
  public get superGenerations() {
    return this._superGenerations;
  }

  /** 设置：实体继承关系集合（当前为父实体） */
  public set superGenerations(value: Array<EntityGeneration>) {
    this._superGenerations = value;
  }

  /** 实体继承关系集合（当前为子实体） */
  private _subGenerations: Array<EntityGeneration>;

  /** 获取：实体继承关系集合（当前为子实体） */
  public get subGenerations() {
    return this._subGenerations;
  }

  /** 设置：实体继承关系集合（当前为子实体） */
  public set subGenerations(value: Array<EntityGeneration>) {
    this._subGenerations = value;
  }

  /** 被引用的实体 */
  private _referenceEntities: Array<BEReferenceEntity>;

  /** 获取：被引用的实体 */
  public get referenceEntities() {
    return this._referenceEntities;
  }

  /** 设置：被引用的实体 */
  public set referenceEntities(value: Array<BEReferenceEntity>) {
    this._referenceEntities = value;
  }

  /** 作为源的双向关联关系 */
  private _sourceCrossAssociations: Array<CrossAssociation>;

  /** 获取：作为源的双向关联关系 */
  public get sourceCrossAssociations() {
    return this._sourceCrossAssociations;
  }

  /** 设置：作为源的双向关联关系 */
  public set sourceCrossAssociations(value: Array<CrossAssociation>) {
    this._sourceCrossAssociations = value;
  }

  /** 作为目标的双向关联关系 */
  private _targetCrossAssociations: Array<CrossAssociation>;

  /** 获取：作为目标的双向关联关系 */
  public get targetCrossAssociations() {
    return this._targetCrossAssociations;
  }

  /** 设置：作为目标的双向关联关系 */
  public set targetCrossAssociations(value: Array<CrossAssociation>) {
    this._targetCrossAssociations = value;
  }

  /** 作为源的引用双向关联关系 */
  private _sourceReferCrossAssociations: Array<ReferCrossAssociation>;

  /** 获取：作为源的引用双向关联关系 */
  public get sourceReferCrossAssociations() {
    return this._sourceReferCrossAssociations;
  }

  /** 设置：作为源的引用双向关联关系 */
  public set sourceReferCrossAssociations(value: Array<ReferCrossAssociation>) {
    this._sourceReferCrossAssociations = value;
  }

  /** 作为源的依赖关系 */
  private _sourceDependencyAssociations: Array<DependencyAssociation>;

  /** 获取：作为源的依赖关系 */
  public get sourceDependencyAssociations() {
    return this._sourceDependencyAssociations;
  }

  /** 设置：作为源的依赖关系 */
  public set sourceDependencyAssociations(value: Array<DependencyAssociation>) {
    this._sourceDependencyAssociations = value;
  }

  /** 作为目标的依赖关系 */
  private _targetDependencyAssociations: Array<DependencyAssociation>;

  /** 获取：作为目标的依赖关系 */
  public get targetDependencyAssociations() {
    return this._targetDependencyAssociations;
  }

  /** 设置：作为目标的依赖关系 */
  public set targetDependencyAssociations(value: Array<DependencyAssociation>) {
    this._targetDependencyAssociations = value;
  }

  /** 属性 */
  private _attributes: Array<BEAttribute>;

  /** 获取：属性 */
  public get attributes() {
    return this._attributes;
  }

  /** 设置：属性 */
  public set attributes(value: Array<BEAttribute>) {
    this._attributes = value;
  }

  /** 方法 */
  private _methods: Array<EntityMethod>;

  /** 获取：方法 */
  public get methods() {
    return this._methods;
  }

  /** 设置：方法 */
  public set methods(value: Array<EntityMethod>) {
    this._methods = value;
  }

  constructor() {
    super();
    BEEntityExtend.Init(this);
    this._accessModifier = EnumAccessModifier.Public;
    this._inheritanceModifier = EnumInheritanceModifier.None;
    this._persistenceType = EnumPersistenceType.RMDB;
    this._defaultTableName = '';
    this._hasInsertingEvent = false;
    this._hasInsertedEvent = false;
    this._hasUpdatingEvent = false;
    this._hasUpdatedEvent = false;
    this._hasDeletingEvent = false;
    this._hasDeletedEvent = false;
    this._hasRestoringEvent = false;
    this._hasRestoredEvent = false;
    this._hasRemovingEvent = false;
    this._hasRemovedEvent = false;
    this._isForFront = true;
    this._needAudit = false;
    this._entityStructureType = EnumEntityStructureType.SingleEntity;
    this._treeEntityLevel = EnumTreeEntityLevel.Level2;
    this._isTenantEntity = true;
    this._superEntity_ID = '';
    this._superEntity = null;
    this._component_ID = '';
    this._component = null;
    this._implements = new Array<Implement>();
    this._sourceAssociations = new Array<Association>();
    this._targetAssociations = new Array<Association>();
    this._sourceAggregations = new Array<Aggregation>();
    this._targetAggregations = new Array<Aggregation>();
    this._sourceCompositions = new Array<Composition>();
    this._targetCompositions = new Array<Composition>();
    this._superGenerations = new Array<EntityGeneration>();
    this._subGenerations = new Array<EntityGeneration>();
    this._referenceEntities = new Array<BEReferenceEntity>();
    this._sourceCrossAssociations = new Array<CrossAssociation>();
    this._targetCrossAssociations = new Array<CrossAssociation>();
    this._sourceReferCrossAssociations = new Array<ReferCrossAssociation>();
    this._sourceDependencyAssociations = new Array<DependencyAssociation>();
    this._targetDependencyAssociations = new Array<DependencyAssociation>();
    this._attributes = new Array<BEAttribute>();
    this._methods = new Array<EntityMethod>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEEntity, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.accessModifier = element.accessModifier;
      this.inheritanceModifier = element.inheritanceModifier;
      this.persistenceType = element.persistenceType;
      this.defaultTableName = element.defaultTableName;
      this.hasInsertingEvent = element.hasInsertingEvent;
      this.hasInsertedEvent = element.hasInsertedEvent;
      this.hasUpdatingEvent = element.hasUpdatingEvent;
      this.hasUpdatedEvent = element.hasUpdatedEvent;
      this.hasDeletingEvent = element.hasDeletingEvent;
      this.hasDeletedEvent = element.hasDeletedEvent;
      this.hasRestoringEvent = element.hasRestoringEvent;
      this.hasRestoredEvent = element.hasRestoredEvent;
      this.hasRemovingEvent = element.hasRemovingEvent;
      this.hasRemovedEvent = element.hasRemovedEvent;
      this.isForFront = element.isForFront;
      this.needAudit = element.needAudit;
      this.entityStructureType = element.entityStructureType;
      this.treeEntityLevel = element.treeEntityLevel;
      this.isTenantEntity = element.isTenantEntity;
      this.superEntity_ID = element.superEntity_ID;
      if (hasReference && element.superEntity !== null) {
        this.superEntity = element.superEntity;
      }
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.inheritanceModifier = json.InheritanceModifier as EnumInheritanceModifier;
    this.persistenceType = json.PersistenceType as EnumPersistenceType;
    this.defaultTableName = json.DefaultTableName;
    this.hasInsertingEvent = json.HasInsertingEvent;
    this.hasInsertedEvent = json.HasInsertedEvent;
    this.hasUpdatingEvent = json.HasUpdatingEvent;
    this.hasUpdatedEvent = json.HasUpdatedEvent;
    this.hasDeletingEvent = json.HasDeletingEvent;
    this.hasDeletedEvent = json.HasDeletedEvent;
    this.hasRestoringEvent = json.HasRestoringEvent;
    this.hasRestoredEvent = json.HasRestoredEvent;
    this.hasRemovingEvent = json.HasRemovingEvent;
    this.hasRemovedEvent = json.HasRemovedEvent;
    this.isForFront = json.IsForFront;
    this.needAudit = json.NeedAudit;
    this.entityStructureType = json.EntityStructureType as EnumEntityStructureType;
    this.treeEntityLevel = json.TreeEntityLevel as EnumTreeEntityLevel;
    this.isTenantEntity = json.IsTenantEntity;
    this.superEntity_ID = json.SuperEntity_ID;
    // if (json.SuperEntity !== null) {
    //   this.superEntity = BEEntity.Create(json.SuperEntity);
    // }
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.Implements && json.Implements.length > 0) {
      json.Implements.forEach((element: any) => {
        const implement = Implement.Create(element);
        // implement.entity = this;
        this.implements.push(implement);
      });
    }
    if (json.SourceAssociations && json.SourceAssociations.length > 0) {
      json.SourceAssociations.forEach((element: any) => {
        const association = Association.Create(element);
        // association.sourceEntity = this;
        this.sourceAssociations.push(association);
      });
    }
    if (json.TargetAssociations && json.TargetAssociations.length > 0) {
      json.TargetAssociations.forEach((element: any) => {
        const association = Association.Create(element);
        // association.targetEntity = this;
        this.targetAssociations.push(association);
      });
    }
    if (json.SourceAggregations && json.SourceAggregations.length > 0) {
      json.SourceAggregations.forEach((element: any) => {
        const aggregation = Aggregation.Create(element);
        // aggregation.sourceEntity = this;
        this.sourceAggregations.push(aggregation);
      });
    }
    if (json.TargetAggregations && json.TargetAggregations.length > 0) {
      json.TargetAggregations.forEach((element: any) => {
        const aggregation = Aggregation.Create(element);
        // aggregation.targetEntity = this;
        this.targetAggregations.push(aggregation);
      });
    }
    if (json.SourceCompositions && json.SourceCompositions.length > 0) {
      json.SourceCompositions.forEach((element: any) => {
        const composition = Composition.Create(element);
        // composition.sourceEntity = this;
        this.sourceCompositions.push(composition);
      });
    }
    if (json.TargetCompositions && json.TargetCompositions.length > 0) {
      json.TargetCompositions.forEach((element: any) => {
        const composition = Composition.Create(element);
        // composition.targetEntity = this;
        this.targetCompositions.push(composition);
      });
    }
    if (json.SuperGenerations && json.SuperGenerations.length > 0) {
      json.SuperGenerations.forEach((element: any) => {
        const entityGeneration = EntityGeneration.Create(element);
        // entityGeneration.superEntity = this;
        this.superGenerations.push(entityGeneration);
      });
    }
    if (json.SubGenerations && json.SubGenerations.length > 0) {
      json.SubGenerations.forEach((element: any) => {
        const entityGeneration = EntityGeneration.Create(element);
        // entityGeneration.subEntity = this;
        this.subGenerations.push(entityGeneration);
      });
    }
    if (json.ReferenceEntities && json.ReferenceEntities.length > 0) {
      json.ReferenceEntities.forEach((element: any) => {
        const bEReferenceEntity = BEReferenceEntity.Create(element);
        // bEReferenceEntity.entity = this;
        this.referenceEntities.push(bEReferenceEntity);
      });
    }
    if (json.SourceCrossAssociations && json.SourceCrossAssociations.length > 0) {
      json.SourceCrossAssociations.forEach((element: any) => {
        const crossAssociation = CrossAssociation.Create(element);
        // crossAssociation.sourceEntity = this;
        this.sourceCrossAssociations.push(crossAssociation);
      });
    }
    if (json.TargetCrossAssociations && json.TargetCrossAssociations.length > 0) {
      json.TargetCrossAssociations.forEach((element: any) => {
        const crossAssociation = CrossAssociation.Create(element);
        // crossAssociation.targetEntity = this;
        this.targetCrossAssociations.push(crossAssociation);
      });
    }
    if (json.SourceReferCrossAssociations && json.SourceReferCrossAssociations.length > 0) {
      json.SourceReferCrossAssociations.forEach((element: any) => {
        const referCrossAssociation = ReferCrossAssociation.Create(element);
        // referCrossAssociation.sourceEntity = this;
        this.sourceReferCrossAssociations.push(referCrossAssociation);
      });
    }
    if (json.SourceDependencyAssociations && json.SourceDependencyAssociations.length > 0) {
      json.SourceDependencyAssociations.forEach((element: any) => {
        const dependencyAssociation = DependencyAssociation.Create(element);
        // dependencyAssociation.sourceEntity = this;
        this.sourceDependencyAssociations.push(dependencyAssociation);
      });
    }
    if (json.TargetDependencyAssociations && json.TargetDependencyAssociations.length > 0) {
      json.TargetDependencyAssociations.forEach((element: any) => {
        const dependencyAssociation = DependencyAssociation.Create(element);
        // dependencyAssociation.targetEntity = this;
        this.targetDependencyAssociations.push(dependencyAssociation);
      });
    }
    if (json.Attributes && json.Attributes.length > 0) {
      json.Attributes.forEach((element: any) => {
        const bEAttribute = BEAttribute.Create(element);
        // bEAttribute.entity = this;
        this.attributes.push(bEAttribute);
      });
    }
    if (json.Methods && json.Methods.length > 0) {
      json.Methods.forEach((element: any) => {
        const entityMethod = EntityMethod.Create(element);
        // entityMethod.entity = this;
        this.methods.push(entityMethod);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AccessModifier = this.accessModifier;
    json.InheritanceModifier = this.inheritanceModifier;
    json.PersistenceType = this.persistenceType;
    json.DefaultTableName = this.defaultTableName;
    json.HasInsertingEvent = this.hasInsertingEvent;
    json.HasInsertedEvent = this.hasInsertedEvent;
    json.HasUpdatingEvent = this.hasUpdatingEvent;
    json.HasUpdatedEvent = this.hasUpdatedEvent;
    json.HasDeletingEvent = this.hasDeletingEvent;
    json.HasDeletedEvent = this.hasDeletedEvent;
    json.HasRestoringEvent = this.hasRestoringEvent;
    json.HasRestoredEvent = this.hasRestoredEvent;
    json.HasRemovingEvent = this.hasRemovingEvent;
    json.HasRemovedEvent = this.hasRemovedEvent;
    json.IsForFront = this.isForFront;
    json.NeedAudit = this.needAudit;
    json.EntityStructureType = this.entityStructureType;
    json.TreeEntityLevel = this.treeEntityLevel;
    json.IsTenantEntity = this.isTenantEntity;
    json.SuperEntity_ID = this.superEntity_ID;
    json.Component_ID = this.component_ID;
    if (this.implements && this.implements.length > 0) {
      json.Implements = [];
      this.implements.forEach((element) => {
        json.Implements.push(element.toJson());
      });
    }
    if (this.sourceAssociations && this.sourceAssociations.length > 0) {
      json.SourceAssociations = [];
      this.sourceAssociations.forEach((element) => {
        json.SourceAssociations.push(element.toJson());
      });
    }
    if (this.targetAssociations && this.targetAssociations.length > 0) {
      json.TargetAssociations = [];
      this.targetAssociations.forEach((element) => {
        json.TargetAssociations.push(element.toJson());
      });
    }
    if (this.sourceAggregations && this.sourceAggregations.length > 0) {
      json.SourceAggregations = [];
      this.sourceAggregations.forEach((element) => {
        json.SourceAggregations.push(element.toJson());
      });
    }
    if (this.targetAggregations && this.targetAggregations.length > 0) {
      json.TargetAggregations = [];
      this.targetAggregations.forEach((element) => {
        json.TargetAggregations.push(element.toJson());
      });
    }
    if (this.sourceCompositions && this.sourceCompositions.length > 0) {
      json.SourceCompositions = [];
      this.sourceCompositions.forEach((element) => {
        json.SourceCompositions.push(element.toJson());
      });
    }
    if (this.targetCompositions && this.targetCompositions.length > 0) {
      json.TargetCompositions = [];
      this.targetCompositions.forEach((element) => {
        json.TargetCompositions.push(element.toJson());
      });
    }
    if (this.superGenerations && this.superGenerations.length > 0) {
      json.SuperGenerations = [];
      this.superGenerations.forEach((element) => {
        json.SuperGenerations.push(element.toJson());
      });
    }
    if (this.subGenerations && this.subGenerations.length > 0) {
      json.SubGenerations = [];
      this.subGenerations.forEach((element) => {
        json.SubGenerations.push(element.toJson());
      });
    }
    if (this.referenceEntities && this.referenceEntities.length > 0) {
      json.ReferenceEntities = [];
      this.referenceEntities.forEach((element) => {
        json.ReferenceEntities.push(element.toJson());
      });
    }
    if (this.sourceCrossAssociations && this.sourceCrossAssociations.length > 0) {
      json.SourceCrossAssociations = [];
      this.sourceCrossAssociations.forEach((element) => {
        json.SourceCrossAssociations.push(element.toJson());
      });
    }
    if (this.targetCrossAssociations && this.targetCrossAssociations.length > 0) {
      json.TargetCrossAssociations = [];
      this.targetCrossAssociations.forEach((element) => {
        json.TargetCrossAssociations.push(element.toJson());
      });
    }
    if (this.sourceReferCrossAssociations && this.sourceReferCrossAssociations.length > 0) {
      json.SourceReferCrossAssociations = [];
      this.sourceReferCrossAssociations.forEach((element) => {
        json.SourceReferCrossAssociations.push(element.toJson());
      });
    }
    if (this.sourceDependencyAssociations && this.sourceDependencyAssociations.length > 0) {
      json.SourceDependencyAssociations = [];
      this.sourceDependencyAssociations.forEach((element) => {
        json.SourceDependencyAssociations.push(element.toJson());
      });
    }
    if (this.targetDependencyAssociations && this.targetDependencyAssociations.length > 0) {
      json.TargetDependencyAssociations = [];
      this.targetDependencyAssociations.forEach((element) => {
        json.TargetDependencyAssociations.push(element.toJson());
      });
    }
    if (this.attributes && this.attributes.length > 0) {
      json.Attributes = [];
      this.attributes.forEach((element) => {
        json.Attributes.push(element.toJson());
      });
    }
    if (this.methods && this.methods.length > 0) {
      json.Methods = [];
      this.methods.forEach((element) => {
        json.Methods.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    context.addRow('代码属性', 'inheritanceModifier', '继承修饰符', EnumDataType.Reference, this.inheritanceModifier, true, '继承修饰符定义实体为抽象或最终类', 'EnumInheritanceModifier', 'PGRowEnumValue');
    context.addRow('持久化', 'persistenceType', '持久化类型', EnumDataType.Reference, this.persistenceType, true, '持久化类型', 'EnumPersistenceType', 'PGRowEnumValue');
    context.addRow('实体事件', 'hasInsertingEvent', '插入前事件', EnumDataType.Bool, this.hasInsertingEvent, true, '是否自动挂接插入前事件，在执行数据库插入之前执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasInsertedEvent', '插入后事件', EnumDataType.Bool, this.hasInsertedEvent, true, '是否自动挂接插入后事件，在执行数据库插入之后执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasUpdatingEvent', '更新前事件', EnumDataType.Bool, this.hasUpdatingEvent, true, '是否自动挂接更新前事件，在执行数据库更新之前执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasUpdatedEvent', '更新后事件', EnumDataType.Bool, this.hasUpdatedEvent, true, '是否自动挂接更新后事件，在执行数据库更新之后执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasDeletingEvent', '逻辑删除前事件', EnumDataType.Bool, this.hasDeletingEvent, true, '是否自动挂接逻辑删除前事件，在执行数据库逻辑删除之前执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasDeletedEvent', '逻辑删除后事件', EnumDataType.Bool, this.hasDeletedEvent, true, '是否自动挂接逻辑删除后事件，在执行数据库逻辑删除之后执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasRestoringEvent', '恢复前事件', EnumDataType.Bool, this.hasRestoringEvent, true, '是否自动挂接恢复前事件，在执行数据库恢复之前执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasRestoredEvent', '恢复后事件', EnumDataType.Bool, this.hasRestoredEvent, true, '是否自动挂接恢复后事件，在执行数据库恢复之后执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasRemovingEvent', '物理删除前事件', EnumDataType.Bool, this.hasRemovingEvent, true, '是否自动挂接物理删除前事件，在执行数据库物理删除之前执行，需要提供扩展实现代码', '', '');
    context.addRow('实体事件', 'hasRemovedEvent', '物理删除后事件', EnumDataType.Bool, this.hasRemovedEvent, true, '是否自动挂接物理删除后事件，在执行数据库物理删除之后执行，需要提供扩展实现代码', '', '');
    context.addRow('代码属性', 'isForFront', '是否前端可见', EnumDataType.Bool, this.isForFront, true, '是否前端可见，false代表不对前端输出，前端不可见', '', '');
    context.addRow('代码属性', 'needAudit', '需要审核', EnumDataType.Bool, this.needAudit, true, '是否需要审核，审核实体会自动生成对应的按钮、权限等信息，新建数据为等待状态，审核通过以后变为有效', '', '');
    context.addRow('代码属性', 'entityStructureType', '实体结构类型', EnumDataType.Reference, this.entityStructureType, false, '实体结构类型', 'EnumEntityStructureType', 'PGRowEnumValue');
    context.addRow('代码属性', 'treeEntityLevel', '树形最大层级', EnumDataType.Reference, this.treeEntityLevel, true, '树形结构实体的最大层级，引用的时候必须选择最大层级的数据', 'EnumTreeEntityLevel', 'PGRowEnumValue');
    context.addRow('代码属性', 'isTenantEntity', '租户实体', EnumDataType.Bool, this.isTenantEntity, true, '是否是租户实体。租户实体在操作的时候会受到租户条件限制', '', '');
    context.addRow('基本属性', 'superEntity', '父实体', EnumDataType.Reference, this.superEntity, true, '与继承线一致的父实体，如果是跨组件继承，则没有继承线。', 'BEEntity', 'PGRowDataTypeValue:BEEntity');
    return context;
  }

  static Create(json: any): BEEntity {
    const bEEntity = new BEEntity();
    bEEntity.Deserialize(json);
    bEEntity.json = json;
    return bEEntity;
  }
}
